export const housingPermitOptions = [
    {
        type: "Single family home",
        applicationLink: "/services/single-family-home"
    },
    {
        type: "Apartment",
        applicationLink: ""
    },
    {
        type: "Duplex",
        applicationLink: ""
    },
    {
        type: "Townhouse",
        applicationLink: ""
    }
];
